import {Injectable} from "@angular/core";
import {EcaseHttpService} from "./ecase-http.service";
import {Observable} from "rxjs/internal/Observable";
import {of} from "rxjs";
import {HttpResponse} from "@angular/common/http";

export interface ApprovalRowDto {
  id: number;
  referenceId: number;
  periodId: number;
  periodLabel: { [key: string]: string };
  approvalDate: string | null;
  caseApplicationId: number;
  isPeriodRequired: boolean;
  applicantUser: {
    ssoUserId?: number;
    crmPersonId?: number;
    firstName?: string;
    familyName?: string;
    username?: string;
  };
  approvalTypeId: number;
  approvalTypeLabel: { [key: string]: string };
  statusId: number | null;
  statusLabel: { [key: string]: string } | null;
  comment: string | null;
  approvalBy: string | null;
  isCompleted: 0 | 1;
}

export interface GetApprovalsRequest {
  /** Mandatory */
  approvalTypeId: number;
  /** Mandatory */
  periodId: number;
  /** -1 all, 0 false, 1 true */
  isCompleted: -1 | 0 | 1;
  subject?: string | null;

  pageNumber: number;
  pageSize: number;
  selectedLanguage: string;
}

export interface GetApprovalsResponse {
  response: ApprovalRowDto[];
  totalCount: number;
}

export interface PeriodOptionDto {
  id: number;
  label: { [key: string]: string };
}

@Injectable({
  providedIn: 'root'
})
export class CrmOrganizationApprovalService {
  constructor(private eCaseHttpService: EcaseHttpService) {

  }

  getAllPeriods(): Observable<PeriodOptionDto[]> {
    return this.eCaseHttpService.get(`/v2_api/crm-organization-approvals/periods`);
  }

  getAllApprovals(request: GetApprovalsRequest): Observable<GetApprovalsResponse> {
    // When backend is ready:
    return this.eCaseHttpService.post(`/v2_api/crm-organization-approvals/get-approvals`, request);
  }

  save(payload: SaveSubmitApprovalPayload[]): Observable<{ status: boolean }> {
    return this.eCaseHttpService.post(`/v2_api/crm-organization-approvals/save-submit`, payload);
  }

  exportToExcel(object: any):  Observable<HttpResponse<Blob>> {
    return this.eCaseHttpService.post(`/api/institutional/exportExcelApprovals`,
      object,
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }
}


export interface SaveSubmitApprovalPayload {
  approvalId: number;
  approvalStatusId: number | null;
  comment?: string | null;
  isSubmit: boolean;
}
